// Add to entities which should be deleted directly instead of with the deleteProduct behaviour
class NonBehaviorDeleteComponent {
    constructor() {
        this.typeId = NonBehaviorDeleteComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
NonBehaviorDeleteComponent.id = 2084;
export default NonBehaviorDeleteComponent;
//# sourceMappingURL=NonBehaviorDeleteComponent.js.map